// extracted by mini-css-extract-plugin
export default {"wrapper":"SummaryBanner_wrapper__oV92w","label":"SummaryBanner_label__foqBO","value":"SummaryBanner_value__pSm97"};